import { render } from "./FieldWrapper.vue?vue&type=template&id=07fcf810&scoped=true"
import script from "./FieldWrapper.vue?vue&type=script&lang=js"
export * from "./FieldWrapper.vue?vue&type=script&lang=js"

import "./FieldWrapper.vue?vue&type=style&index=0&id=07fcf810&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07fcf810"]])

export default __exports__